<div class="smart-table-container">


  <button class="add-or-edit-button" mat-mini-fab color="primary" (click)="addOrEditClicked()">
    <mat-icon matSuffix>{{'add'}}</mat-icon>
  </button>


  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

    <ng-container *ngFor="let column of config.columns" matColumnDef={{column.dataKey}}>
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{(column.labelKey) | translate}}</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!column.isImage && !column.isDate">{{element[column.dataKey]}}</ng-container>
        <ng-container *ngIf="column.isImage && element[column.dataKey]">
          <img [src]="element[column.dataKey]">
        </ng-container>

        <ng-container *ngIf="column.isDate">
          {{ element[column.dataKey] | localizedDate}}
        </ng-container>

        </td>
    </ng-container>


    <ng-container matColumnDef="deleteColumn">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell  *matCellDef="let element" (click)="showDeleteModal($event, element)">
        <mat-icon class="dark" >delete</mat-icon>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="config.displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: config.displayedColumns;" (click)="addOrEditClicked(row)"></tr>
  </table>

</div>
